import * as React from 'react';
import { cn } from '@lib/cn';

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string;
  alt?: string;
  size?: 'sm' | 'md' | 'lg';
  showOnline?: boolean;
}

const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  ({ className, src, alt = 'Avatar', size = 'md', showOnline = false, ...props }, ref) => {
    const sizes = {
      sm: 'h-6 w-6 text-[20px]',
      md: 'h-8 w-8 text-[24px]',
      lg: 'h-10 w-10 text-[28px]',
    };

    const onlineSizes = {
      sm: 'h-2 w-2 border',
      md: 'h-2.5 w-2.5 border',
      lg: 'h-2.5 w-2.5 border-2',
    };

    return (
      <div ref={ref} className={cn('relative inline-block', className)} {...props}>
        <div
          className={cn('overflow-hidden rounded-full border border-[--base-border]', sizes[size])}
        >
          {src ? (
            <img src={src} alt={alt} className="h-full w-full object-cover" />
          ) : (
            <div className="flex h-full w-full items-center justify-center text-[--base-fill-5]">
              <i className="ri-user-smile-line" />
            </div>
          )}
        </div>
        {showOnline && (
          <div
            className={cn(
              'absolute bottom-0 right-0 rounded-full bg-[--state-brand-active] border-[--base-surface-1]',
              onlineSizes[size],
            )}
          />
        )}
      </div>
    );
  },
);

Avatar.displayName = 'Avatar';

export { Avatar };
